// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
	Input,
	Select
} from "../../../_metronic/_partials/controls";

import { useIntl } from "react-intl";


export function EditForm({ saveItem, item, actionsLoading, onHide }) {

	const intl = useIntl();

	return (
		<>
			<Formik
				enableReinitialize={true}
				initialValues={item}
				onSubmit={(values) => {
					saveItem(values);
				}}
			>
				{({ handleSubmit }) => (
					<>
						<Modal.Body className="overlay overlay-block cursor-default">
							{actionsLoading && (
								<div className="overlay-layer bg-transparent">
									<div className="spinner spinner-lg spinner-success" />
								</div>
							)}
							<Form className="form form-label-right">
								<div className="form-group row">
									<label className="col-xl-3 col-lg-3 col-form-label">
										{ intl.formatMessage({ id: "Table.Customer.Nickname" }) }
									</label>
									<div className="col-lg-9 col-xl-9">
										<Field
											name="nickname"
											component={Input}
											placeholder={ intl.formatMessage({ id: "Table.Customer.Nickname" }) }
										/>
									</div>
								</div>
							</Form>
						</Modal.Body>
						<Modal.Footer>
							<button
								type="button"
								onClick={onHide}
								className="btn btn-light btn-elevate"
							>
								{ intl.formatMessage({ id: "Table.Cancel" }) }
							</button>
							<> </>
							<button
								type="submit"
								onClick={() => handleSubmit()}
								className="btn btn-primary btn-elevate"
							>
								{ intl.formatMessage({ id: "Table.Save" }) }
							</button>
						</Modal.Footer>
					</>
				)}
			</Formik>
		</>
	);
}
